<template>
  <div class="fondo d-flex align-items-center">
    <div class="container">
      <div class="row p-5 align-items-end">
        <div class="col"></div>
        <div class="recuadro login col-4 bg-light p-5">
          <h1 class="text-center">Bienvenido a SMARTCLIC</h1>
          <form v-on:submit.prevent="btnLogin_click">
            <input type="text" class="form-control mb-3" name="usr_usr" id="usr_usr" v-model="usuario.user"
              placeholder="Usuario" required>
            <input type="password" class="form-control mb-3" name="usr_pas" id="usr_pas" v-model="usuario.pass"
              placeholder="Contraseña" required>
            <div class="d-grid gap-2">
              <input type="submit" class="btn btn-primary" value="Iniciar Sesión">
            </div>
          </form>
        </div>
        <div class="col"></div>
      </div>
    </div>
  </div>
</template>
<script>
import utils from '@/functions/utils';
import clientesService from '@/services/clientes.service';
import authService from '@/services/auth.service';
import spinner from '@/services/spinner.service';

export default {
  data() {
    return {
      loading: false,
      usuario: {}
    }
  },
  methods: {
    async btnLogin_click() {
      if (this.loading) return;

      this.loading = true;
      spinner.show();
      try {
        let obj = {
          Username: this.usuario.user,
          Password: this.usuario.pass
        }
        
        let res = await clientesService.login(obj);
        authService.setToken(res.token);
        this.loading = false;
        this.$router.push({
          path: `/info/contratos`,
        });
      } catch (error) {
        this.loading = false;
        utils.mostrarMensajeError(error.Message || 'Usuario o Contraseña incorrectas')
      } finally{
        spinner.hide();
      }

    }
  }
}

</script>
